(function () {
  "use strict";

  function initBrandsPage() {
    const brandsLists = document.querySelectorAll("[data-brands-list]");

    brandsLists.forEach(function (brandsList) {
      const sectionId = brandsList.getAttribute("data-brands-list");
      const alphabet = document.getElementById("alphabet-filter-" + sectionId);

      if (!alphabet) return;

      const brands = brandsList.querySelectorAll(".brand");
      const alphabetChildren = alphabet.children;

      // Collect all available letters
      const availableLetters = new Set();
      brands.forEach(function (brand) {
        const letter = brand.getAttribute("data-letter");
        if (letter) {
          availableLetters.add(letter.toLowerCase());
        }
      });

      // Enable alphabet links that have brands
      Array.from(alphabetChildren).forEach(function (child) {
        const link = child.querySelector("a");
        if (!link) return;

        const linkText = link.textContent.trim().toLowerCase();

        // Skip "All" link
        if (link.classList.contains("all-brand-link")) return;

        // Enable if letter has brands
        if (availableLetters.has(linkText)) {
          const parentLi = child;

          // Remove unavailable state
          parentLi.classList.remove("tw-bg-[#F3F3F0]", "tw-cursor-not-allowed", "tw-text-[#9E9E98]");
          link.classList.remove("tw-pointer-events-none", "tw-line-through");

          // Add available state
          parentLi.classList.add("tw-cursor-pointer");
          link.classList.add("tw-pointer-events-auto", "tw-text-[#212120]");
        }
      });

      // Handle vendor letter clicks
      const vendorLetters = alphabet.querySelectorAll(".vendor-letter");

      vendorLetters.forEach(function (li) {
        const link = li.querySelector("a");
        if (!link || link.classList.contains("tw-pointer-events-none")) return;

        li.addEventListener("click", function (e) {
          e.preventDefault();
          const clickedLetter = link.textContent.trim().toLowerCase();

          // Remove active state from all items
          const allLis = alphabet.querySelectorAll("li");
          allLis.forEach(function (item) {
            item.classList.remove("active", "tw-text-[#212120]", "tw-border-[#212120]");

            // Reset to default state
            if (item.classList.contains("vendor-letter") || item.classList.contains("alphabet-all")) {
              item.classList.add("tw-border-[#D6D6D2]");
            }
          });

          // Add active state to clicked item
          this.classList.add("active");
          this.classList.remove("tw-border-[#D6D6D2]");
          this.classList.add("tw-border-[#212120]", "tw-text-[#212120]");

          // Show only matching brands
          brands.forEach(function (brand) {
            const brandLetter = brand.getAttribute("data-letter");

            if (brandLetter && brandLetter.toLowerCase() === clickedLetter) {
              brand.classList.remove("tw-hidden");
            } else {
              brand.classList.add("tw-hidden");
            }
          });
        });
      });

      // Handle "All" brand click
      const allBrandLi = alphabet.querySelector(".alphabet-all");

      if (allBrandLi) {
        allBrandLi.addEventListener("click", function (e) {
          e.preventDefault();

          // Remove active state from all items
          const allLis = alphabet.querySelectorAll("li");
          allLis.forEach(function (item) {
            item.classList.remove("active", "tw-border-[#212120]");

            // Reset to default state
            if (item.classList.contains("vendor-letter") || item.classList.contains("alphabet-all")) {
              item.classList.add("tw-border-[#D6D6D2]");
            }
          });

          // Add active state to "All" item
          this.classList.add("active");
          this.classList.remove("tw-border-[#D6D6D2]");
          this.classList.add("tw-border-[#212120]");

          // Show all brands
          brands.forEach(function (brand) {
            brand.classList.remove("tw-hidden");
          });
        });
      }

      // Drag to scroll functionality for desktop
      const scrollContainer = alphabet;

      if (scrollContainer) {
        let isDown = false;
        let startX;
        let scrollLeft;
        let hasDragged = false;

        scrollContainer.addEventListener("mousedown", function (e) {
          isDown = true;
          hasDragged = false;
          scrollContainer.style.cursor = "grabbing";
          startX = e.pageX - scrollContainer.offsetLeft;
          scrollLeft = scrollContainer.scrollLeft;
        });

        scrollContainer.addEventListener("mouseleave", function () {
          isDown = false;
          scrollContainer.style.cursor = "grab";
        });

        scrollContainer.addEventListener("mouseup", function () {
          isDown = false;
          scrollContainer.style.cursor = "grab";
        });

        scrollContainer.addEventListener("mousemove", function (e) {
          if (!isDown) return;
          e.preventDefault();
          hasDragged = true;
          const x = e.pageX - scrollContainer.offsetLeft;
          const walk = (x - startX) * 1;
          scrollContainer.scrollLeft = scrollLeft - walk;
        });

        // Prevent clicks when dragging
        scrollContainer.addEventListener(
          "click",
          function (e) {
            if (hasDragged) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
          true,
        );

        // Set initial cursor
        scrollContainer.style.cursor = "grab";
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBrandsPage);
  } else {
    initBrandsPage();
  }
})();
